<template>
  <div class="container">
    <!-- section1 -->
     <section class="section section-1" id="section-1">
      <div class="container full-container">
        <h2 class="vision">
          <span>巡回健診は</span><br/>
          <span> “自施設で所有する” 時代から</span><wbr/>
          <span> “必要な時だけ借りる” 時代へ</span>
        </h2>
        <div class="message">
          <p>
果たして巡回健診のパーティを自施設で保有する必要がありますか？
          </p>
          <p>
ご存じの通り、健康診断は繁忙期・閑散期のはっきりしている事業ですので<br/>
一年中稼働していない巡回健診パーティであれば、<br/>
いっそのこと必要な時だけアウトソーシングする形にしてしまうのも<br/>業務の効率化につながると考えます。
          </p>
        </div>
      </div>
     </section>

    <!-- section2 -->
     <section class="section section-2" id="section-2">
      <h2 class="vision">メディカルサンテのご紹介</h2>
      <div class="about-container">
        <div class="about-image">
          <img src="../assets/ハートを持つ家族.png" alt="ハートを持つ家族 (c)illustman.net" class="illust" />
        </div>
        <div class="about-column">
<p>当社は、巡回健康診断業務を専門とするサポート会社として、医療機関様・健診機関様の円滑な健診運営を支援しています。</p>
<p>豊富な現場経験と柔軟な対応力を活かし、会場設営、受付、誘導、健診補助など、巡回健診に関わるさまざまな業務をサポートいたします。</p>
<p>迅速で丁寧な対応を心がけ、受診者様に安心して健診を受けていただける環境づくりを大切にしています。</p>
<p>医療機関様の負担を軽減し、効率的で質の高い巡回健診の実現に貢献いたします。</p>
        </div>
        <div class="about-image">
          <img src="../assets/視力検査.png" alt="視力検査 (c)illustman.net" class="illust" />
        </div>
      </div>
     </section>

    <!-- section3 -->
     <section class="section section-3" id="section-3">
      <h2 class="vision">メディカルサンテが承ります</h2>
      <div class="sales-container">
        <div class="sales-image">
          <img src="../assets/レントゲン車.jpg" alt="レントゲン車" class="car" />
        </div>
        <div class="sales-column">
<p>巡回健康診断の現場を、よりスムーズに。</p>
<p>当社は巡回健診業務の下請け・運営サポートを専門に行っています。健診会場の設営から受付、誘導、健診補助まで、経験豊富なスタッフが現場を支えます。</p>
<p>巡回健診は現場対応力が重要です。私たちは「迅速・正確・丁寧」をモットーに、医療機関様の負担軽減と健診現場の円滑な運営を実現します。</p>
<p>小規模案件から大規模健診まで柔軟に対応可能です。巡回健診業務のパートナーとして、ぜひ当社をご活用ください。</p>
        </div>
      </div>
     </section>

    <!-- section4 -->
     <section class="section section-4" id="section-4">
      <h2 class="vision">会社概要・事業内容</h2>
      <div class="split-container">
        <div class="split-logo">
          <img src="../assets/medicalsante_logo.png" alt="メディカルサンテ コーポレートアイコン" class="corp" />
        </div>
        <div class="split-column">
          <h2 class="vision">事業内容</h2>
          <ul class="info-list bagtag">
            <li>巡回健康診断の代行、<wbr/>機材・車両（胸部/胃部レントゲン）のレンタル</li>
            <li>健康診断に係る医療人材の紹介</li>
            <li>インフルエンザ予防接種支援業務</li>
            <li>脂質異常症検査<wbr/>（リポタンパク分画/PAG濃度図解析）<wbr/>受託業務</li>
            <li>遠隔画像読影受託業務</li>
            <li>健診・ドック施設運営の支援</li>
            <li>産業医・衛生管理者専任に係る支援</li>
          </ul>
        </div>
        <div class="split-column">
          <h2 class="vision">会社概要</h2>
          <dl class="info-table">
            <dt class="info-left">会社名</dt> <dd class="info-right">合同会社メディカルサンテ</dd>
            <dt class="info-left">所在地</dt> <dd class="info-right">〒357-0055 埼玉県飯能市 上直竹下分34番地</dd>
            <dt class="info-left">代表</dt>   <dd class="info-right">浅見 通</dd>
            <dt class="info-left">電話番号</dt><dd class="info-right">042-977-1333</dd>
            <dt class="info-left">FAX番号</dt><dd class="info-right">042-977-1333</dd>
            <dt class="info-left">設立</dt>   <dd class="info-right">2023年12月21日</dd>
            <dt class="info-left">法人番号</dt><dd class="info-right">8030003023277</dd>
          </dl>
          <h2 class="vision">提携先</h2>
          <ul class="info-list institute">
            <li><a rel="nofollow" href="https://aska-labo.com">株式会社明日香特殊検査研究所</a></li>
            <li><a rel="nofollow" href="http://www.n-kenshin.co.jp/pages/35/">株式会社日本健診センター</a></li>
          </ul>
        </div>
        <div class="split-map">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3031.987373867131!2d139.25448197554445!3d35.84606427253452!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60192f6277b2b691%3A0xfa2ee539b760cb5e!2z44CSMzU3LTAwNTUg5Z-8546J55yM6aOv6IO95biC5LiK55u056u55LiL5YiG77yT77yU!5e1!3m2!1sja!2sjp!4v1773319435066!5m2!1sja!2sjp" width="640" height="723" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
     </section>

    <!-- section5 -->
     <section class="section section-5" id="section-5">
      <h2 class="vision">お問い合わせ</h2>
      <ul class="form-notice">
        <li>お問い合わせフォームはGoogleのシステムを使用しています。</li>
        <li>Googleアカウントでログインし、ご記入ください。Googleアカウント名はメディカルサンテには通知されません。</li>
        <li>いただいた内容は弊社担当が業務対応でのみ参照し、第三者への公開はいたしません。</li>
        <li>メールでの折り返しをご希望の場合 @medical-sante.co.jp からのメールの着信を許可していただく必要があります。</li>
      </ul>
      <div class="desktop">
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSctPIFQbTdDyS14lJ4HpmCXiypTayhnF84VqBhSc8aVVT7R9w/viewform?embedded=true" width="640" height="800" frameborder="0" marginheight="0" marginwidth="0">読み込んでいます…</iframe>
      </div>
      <div class="mobile">
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSctPIFQbTdDyS14lJ4HpmCXiypTayhnF84VqBhSc8aVVT7R9w/viewform?embedded=true">お問い合わせフォームへ</a>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HelloSante',
  props: {
    msg: String
  }
}
</script>

<style>
body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: sans-serif;
}
.container {
  height: 100vh;
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
}
.section {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  scroll-snap-align: start;
  color: white;
}

/* section1 */
.full-container {
  width: 100%;
  /* height: 100vh; */
  justify-content: center;
  align-items: center;
  background-image: url("~@/assets/配車.png");
  background-size: cover;
  background-position: 75% 50%;
  padding: 100px;
}
.vision {
  font-size: 1.9rem;
  font-family: "Sawarabi Mincho", "Hiragino Mincho", "MS Mincho";
  word-break: keep-all;
  overflow-wrap: anywhere;
}
.message{
  font-size: 1.1rem;
  /* background: rgba(0, 0, 0, 0.25); */
  color: white;
  /* -webkit-text-stroke: 2px #ccc; */
  text-shadow:
    0 0 4px #333,
    0 0 8px #333;
  padding: 4px 8px;
  display: inline-block;
}
@media (max-width: 600px) {
  .vision {
    font-size: 1.2rem;
  }
  .message {
    font-size: 0.7rem;
  }
}

/* section2 */
.about-container {
  display: flex;
}
.about-image {
  flex: 2;
  padding: 10px;
}
.about-column {
  flex: 2;
  padding: 20px;
  /* overflow-y: auto; */
  text-align: left;
}
@media (min-aspect-ratio: 4/3) {
  .about-column {
    flex: 3;
  }
}
.illust {
  width: 100%;
}
@media (max-width: 600px) {
  .about-container {
    flex-direction: column;
  }
  .about-column {
    flex: 3;
  }
  .illust {
    width: 25%;
  }
}

/* section3 */
.sales-container {
  display: flex;
  /* grid-template-columns: 1fr; */
  gap: 16px;
  /* padding: 16px; */
}
.sales-image {
  flex: 1;
}
.sales-column {
  flex: 2;
  text-align: left;
  padding: 20px;
}
@media (min-aspect-ratio: 4/3) {
  .sales-column {
    flex: 3;
  }
}
.car {
  border-radius: 20px;
  width: 100%;
}
@media (max-width: 600px) {
  .sales-container {
    flex-direction: column;
  }
  .car {
    width: 25%;
  }
}

/* section4 */
.split-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  padding: 16px;
}
.corp {
  border-radius: 20px;
  width: 33%;
}
.split-logo {
  flex: 1;
  padding: 10px;
}
.split-column {
  flex: 1;
  padding: 20px;
  border: 1px solid #ccc;
}
.split-map {
  flex: 1;
  padding: 20px;
  border: 1px solid #ccc;
}
.split-map iframe {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
@media (max-width: 600px) {
  .section-4 {
    height: 150vh;
  }
  .split-column, .split-map {
    padding: 3px;
    margin: 6px;
  }
}
@media (min-width: 601px) and (max-width: 1023px) {
  .split-container {
    grid-template-columns: repeat(2, 1fr);
  }
  .split-logo {
    grid-column: 1 / 3;
  }
  .split-map {
    grid-column: 1 / 3;
  }
  .corp {
    width: 20%;
  }
}
@media (min-width: 1024px) {
  .section-4 {
    height: 100vh;
  }
  .split-container {
    grid-template-columns: repeat(3, 1fr);
  }
  .split-logo {
    grid-column: 1 / 4;
  }
  .corp {
    width: 12%;
  }
}
.info-list {
  text-align: left;
  /* list-style-type: square; */
  word-break: keep-all;
}
.info-list li {
  position: relative;
}
.info-list.bagtag li::before {
  content: '🏷️';
  position: absolute;
  left: -30px;
}
.info-list.institute li::before {
  content: '🏥';
  position: absolute;
  left: -30px;
}
.info-table {
  /* grid-template-columns: 2fr 3fr; */
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.info-left {
  width: 30%;
}
.info-right {
  width: 70%;
  margin: 0;
  word-break: keep-all;
}

/* section5 */
.form-notice {
  text-align: left;
  width: 80%;
  list-style-type: none;
}
.form-notice li {
  position: relative;
}
.form-notice li::before {
  content: '🏷️';
  position: absolute;
  left: -30px;
}
.section-5 {
  height: 150vh;
  vertical-align: top;
}
@media (max-width: 600px) {
  .section-5 {
    height: 100vh;
  }
}
/* .section-5 .desktop iframe {
  text-align: center;
} */
.section-5 .mobile a {
  /* text-align: center; */
  display: inline-block;
  padding: 10px 10px;
  background-color: #1e9deb;
  color: #ffffff;
  text-decoration: none;
  border-radius: 10px;
}

.section-1,.section-4 { background-color: #3485db; }
.section-2,.section-5 { background-color: #2eaccc; }
.section-3,.section-6 { background-color: #588de8; }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* h2 {
  font-size: 2rem;
  margin-bottom: 0.5rem;
} */
/* h3 {
  margin: 40px 0 0;
} */
/* ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
} */
/* a {
  color: #42b983;
} */
</style>
